<template>
  <f-box bleed neutral class="my-32 md:p-24">
    <h3 class="mb-16 antialiased">Spar penger på lån du har i dag</h3>
    <div class="md:grid f-grid grid-cols-2 grid-gap-24 space-y-24 md:space-y-0">
      <other-link
        :tracking="lendoTracking"
        :href="lendoHref"
        title="Sjekk hva du har i gjeld og hva du kan spare"
        text="Det kan være mange kroner å spare ved å refinansiere."
        target="_blank"
        rel="noopener noreferrer nofollow" />
    </div>
  </f-box>
</template>

<script>
import { h } from 'vue'
import { trackEvent } from '@finn-no/pulse-sdk'

const OtherLink = props => h('div', [
  h('a', { class: 'block mb-4 font-bold', href: props.href, onClick: () => trackEvent(props.tracking), rel: props.rel, target: props.target }, props.title),
  h('p', { class: 'mb-0' }, props.text)
])

export default {
  components: { OtherLink },
  setup() {
    const lendoHref = "https://www.lendo.no/gjeldsregister/min-gjeld/"
    const lendoTracking = {
      type: 'Click',
      intent: 'Open',
      name: 'Refinance offer',
      object: {
        type: 'UIElement',
        elementType: 'link',
      },
      target: {
        id: lendoHref,
        type: 'ExternalContent',
        name: 'Go to webpage',
        provider: 'Lendo',
        referralCommission: false
      },
    }

    return { lendoTracking, lendoHref }
  }
}
</script>
